export function getItemsCount(state) {
    return state.items
        .filter(item => item.quantity > 0)
        .map(item => item.quantity)
        .reduce((acc, next) => acc + next, 0);
}
